<template>
  <div class="template">
    <InstructionDesktop class="template__Desktop" />
    <InstructionMobile class="template__Mobile" />
  </div>
</template>

<script>
import InstructionDesktop from '@/components/services/Instruction/InstructionDesktop.vue'
import InstructionMobile from '@/components/services/Instruction/InstructionMobile.vue'
export default {
  name: 'InstructionView',
  components: {
    InstructionDesktop,
    InstructionMobile
  }
}
</script>


<style lang="scss">


.template__Desktop {
  display: none;
}

.template__Mobile {
  display: block;
}

@media screen and (min-width: 1024px) {
  .template__Desktop {
    display: block;
  }

  .template__Mobile {
    display: none;
  }
}
</style>